import { BlogCardTemplate, BlogCardTemplateProps } from "./template";

export type BlogCardProps = BlogCardTemplateProps;

export const BlogCard = (props: BlogCardProps): JSX.Element => {
  return <BlogCardTemplate {...props} />;
};
